import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import TutorialModal from './ui/TutorialModal';
import ShareMenu from './ShareMenu';

const Footer = () => {
  const [isOpenTutorial, setIsOpenTutorial] = useState(false);

  return (
    <footer className="bg-tax-lightGray border-t border-tax-borderGray mt-12">
      <div className="container py-8 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <h3 className="font-semibold text-lg mb-4 text-tax-deepBlue">
              PropertyTaxHero.com
            </h3>
            <p className="text-sm text-tax-neutralGray mb-4">
              The official free tool that helps homeowners appeal their property
              tax assessments to potentially lower their tax bills. No hidden
              fees. No data selling.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-tax-deepBlue">
              Appeal Guides
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/how-to-appeal-property-tax"
                  className="text-tax-neutralGray hover:text-tax-brightBlue transition-colors"
                >
                  How to Appeal Property Tax
                </Link>
              </li>
              <li>
                <Link
                  to="/lower-property-tax-bill"
                  className="text-tax-neutralGray hover:text-tax-brightBlue transition-colors"
                >
                  Lower Your Tax Bill
                </Link>
              </li>
              <li>
                <Link
                  to="/property-tax-protest"
                  className="text-tax-neutralGray hover:text-tax-brightBlue transition-colors"
                >
                  Property Tax Protest Guide
                </Link>
              </li>
              <li>
                <Link
                  to="/property-tax-comparable-sales-guide"
                  className="text-tax-neutralGray hover:text-tax-brightBlue transition-colors"
                >
                  Comparable Sales Guide
                </Link>
              </li>
              <li>
                <Link
                  to="/property-tax-appeal-deadlines"
                  className="text-tax-neutralGray hover:text-tax-brightBlue transition-colors"
                >
                  Appeal Deadlines by State
                </Link>
              </li>
              <li>
                <Link
                  to="/property-tax-appeal-faq"
                  className="text-tax-neutralGray hover:text-tax-brightBlue transition-colors"
                >
                  Appeal FAQ
                </Link>
              </li>
              <li>
                <button
                  onClick={() => setIsOpenTutorial(true)}
                  className="text-tax-neutralGray hover:text-tax-brightBlue transition-colors"
                >
                  Video Tutorial
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-tax-deepBlue">
              Popular States
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/california"
                  className="text-tax-neutralGray hover:text-tax-brightBlue transition-colors"
                >
                  California Property Taxes
                </Link>
              </li>
              <li>
                <Link
                  to="/texas"
                  className="text-tax-neutralGray hover:text-tax-brightBlue transition-colors"
                >
                  Texas Property Taxes
                </Link>
              </li>
              <li>
                <Link
                  to="/florida"
                  className="text-tax-neutralGray hover:text-tax-brightBlue transition-colors"
                >
                  Florida Property Taxes
                </Link>
              </li>
              <li>
                <Link
                  to="/new-york"
                  className="text-tax-neutralGray hover:text-tax-brightBlue transition-colors"
                >
                  New York Property Taxes
                </Link>
              </li>
              <li>
                <Link
                  to="/illinois"
                  className="text-tax-neutralGray hover:text-tax-brightBlue transition-colors"
                >
                  Illinois Property Taxes
                </Link>
              </li>
              <li className="pt-2">
                <Link
                  to="/all-states"
                  className="text-tax-brightBlue hover:text-tax-deepBlue font-medium transition-colors"
                >
                  View All 50 States →
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-tax-deepBlue">Company</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/about"
                  className="text-tax-neutralGray hover:text-tax-brightBlue transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/pricing"
                  className="text-tax-neutralGray hover:text-tax-brightBlue transition-colors"
                >
                  Pricing
                </Link>
              </li>
              <li>
                <Link
                  to="/agents"
                  className="text-tax-neutralGray hover:text-tax-brightBlue transition-colors"
                >
                  For Agents
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-tax-neutralGray hover:text-tax-brightBlue transition-colors"
                >
                  FAQ
                </Link>
              </li>
              <li>
                <Link
                  to="/non-disclosure-states"
                  className="text-tax-neutralGray hover:text-tax-brightBlue transition-colors"
                >
                  Non-Disclosure States
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-tax-neutralGray hover:text-tax-brightBlue transition-colors"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/methodology"
                  className="text-tax-neutralGray hover:text-tax-brightBlue transition-colors"
                >
                  Methodology
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-tax-neutralGray hover:text-tax-brightBlue transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-tax-neutralGray hover:text-tax-brightBlue transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Important Disclaimer */}
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mt-8 mb-8">
          <div className="text-sm text-gray-700">
            <div className="flex items-start">
              <span className="text-yellow-600 mr-2 text-base">⚠️</span>
              <div>
                <strong className="text-gray-900">
                  Important Note (Our Cape Isn't Bulletproof):
                </strong>
                <p className="mt-1">
                  Neither PropertyTaxHero.com nor any featured agent is giving
                  financial or legal advice. Much of this site's content is
                  generated by Artificial Intelligence and may be wrong,
                  outdated, or just plain quirky. Use this site as a starting
                  point only—you must verify all information, dates, deadlines,
                  and procedures with your local tax assessor's office. By using
                  this site, you agree to release PropertyTaxHero.com, its
                  owners, employees, and any referring real estate agent or
                  brokerage from all liability. 🚀 Use at your own risk.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-tax-borderGray pt-8 flex flex-col items-center gap-4 text-sm text-tax-neutralGray">
          <ShareMenu variant="button" />
          <p>
            &copy; {new Date().getFullYear()} YourWayHome.com LLC. All rights
            reserved. PropertyTaxHero is the official site at{' '}
            <a
              href="https://propertytaxhero.com"
              className="text-tax-brightBlue hover:underline"
            >
              propertytaxhero.com
            </a>
            . Use of this site is subject to our{' '}
            <Link to="/terms" className="text-tax-brightBlue hover:underline">
              Terms of Service
            </Link>{' '}
            and{' '}
            <Link to="/privacy" className="text-tax-brightBlue hover:underline">
              Privacy Policy
            </Link>
            .
          </p>
        </div>
      </div>
      <TutorialModal
        isOpen={isOpenTutorial}
        setIsOpen={() => setIsOpenTutorial(false)}
      />
    </footer>
  );
};

export default Footer;
